var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRelumeColorLargereact = function SvgRelumeColorLargereact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 55,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#relume_color_large_react_svg__a)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#relume_color_large_react_svg__b)",
    fillRule: "evenodd",
    d: "m42.831 16.88.256.457a6.632 6.632 0 0 1 .881 3.292v13.557a6.72 6.72 0 0 1-.885 3.277l-.016.03-.259.43a6.457 6.457 0 0 1-2.431 2.42l-11.69 6.76-.003.002a6.632 6.632 0 0 1-3.314.894h-.482a6.494 6.494 0 0 1-3.341-.9L9.81 40.341l-.025-.015a6.858 6.858 0 0 1-2.35-2.35l-.025-.041-.257-.46a6.631 6.631 0 0 1-.882-3.292V20.647a6.632 6.632 0 0 1 .882-3.293l.245-.438.01-.018a6.632 6.632 0 0 1 2.421-2.42l11.707-6.77.002-.002a6.632 6.632 0 0 1 3.314-.893h.517a6.631 6.631 0 0 1 3.312.893l.004.002 11.708 6.752a6.755 6.755 0 0 1 2.415 2.382l.022.038ZM27.11 10.425l11.71 6.754a3.6 3.6 0 0 1 1.292 1.274l.244.436a3.44 3.44 0 0 1 .41 1.097c.04.213.06.43.061.648V34.16a3.578 3.578 0 0 1-.471 1.745l-.262.436c-.299.534-.74.975-1.274 1.274l-11.71 6.771a3.491 3.491 0 0 1-1.745.472h-.489a3.349 3.349 0 0 1-1.745-.471l-11.728-6.754a3.717 3.717 0 0 1-1.274-1.274l-.244-.437a3.49 3.49 0 0 1-.471-1.745V20.652a3.488 3.488 0 0 1 .47-1.745l.245-.437a3.491 3.491 0 0 1 1.274-1.274l11.71-6.771a3.493 3.493 0 0 1 1.745-.471h.507a3.492 3.492 0 0 1 1.745.471Zm8.482 8.918-10.227-5.899h-.506l-10.21 5.899 10.471 6.038 10.472-6.038ZM25.12 21.755l4.184-2.412-4.191-2.418-4.18 2.415 4.187 2.415Zm1.745 6.663v12.077l10.21-5.9.262-.435V22.362l-10.472 6.056Zm7.33-.61-4.188 2.422v4.822l4.188-2.42v-4.824Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    fillRule: "evenodd",
    d: "m41.714 13.36-.27-.481a3.985 3.985 0 0 0-1.423-1.405L27.106 4.026a3.85 3.85 0 0 0-1.925-.52h-.558c-.676.001-1.34.18-1.924.52L9.784 11.493a3.85 3.85 0 0 0-1.405 1.405l-.27.481a3.848 3.848 0 0 0-.519 1.925V30.22c.001.676.18 1.34.52 1.925l.27.48a4.1 4.1 0 0 0 1.404 1.406l12.934 7.448a3.693 3.693 0 0 0 1.925.52h.538a3.849 3.849 0 0 0 1.925-.52l12.915-7.468a3.658 3.658 0 0 0 1.405-1.405l.288-.48c.335-.587.514-1.25.52-1.925V15.285a3.848 3.848 0 0 0-.52-1.925Zm-17.09-6.005h.558L36.46 13.86l-11.548 6.66-11.548-6.66 11.26-6.505Zm2.213 29.832 11.259-6.505.289-.481V17.19l-11.548 6.678v13.318Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#relume_color_large_react_svg__c)",
    fillRule: "evenodd",
    d: "m44.445 11.102.282.505a7.313 7.313 0 0 1 .972 3.63v14.951a7.41 7.41 0 0 1-.976 3.615l-.018.032-.285.475a7.122 7.122 0 0 1-2.682 2.67l-12.892 7.454-.002.002a7.313 7.313 0 0 1-3.655.986h-.532a7.162 7.162 0 0 1-3.685-.993L8.03 36.976l-.027-.017a7.564 7.564 0 0 1-2.592-2.592l-.027-.045-.284-.507a7.313 7.313 0 0 1-.972-3.63V15.256a7.314 7.314 0 0 1 .972-3.63l.27-.483.013-.02a7.314 7.314 0 0 1 2.67-2.67L20.961.987l.002-.001A7.314 7.314 0 0 1 24.618 0h.571a7.313 7.313 0 0 1 3.657.987l12.912 7.447a7.45 7.45 0 0 1 2.662 2.627l.025.041ZM27.107 3.984l12.915 7.448a3.974 3.974 0 0 1 1.424 1.405l.27.482a3.797 3.797 0 0 1 .45 1.209c.046.235.069.474.07.715V30.16a3.947 3.947 0 0 1-.52 1.925l-.29.481a3.658 3.658 0 0 1-1.404 1.405l-12.915 7.468a3.85 3.85 0 0 1-1.924.52h-.54a3.694 3.694 0 0 1-1.924-.52L9.785 33.989a4.101 4.101 0 0 1-1.405-1.405l-.269-.48a3.848 3.848 0 0 1-.52-1.925V15.262a3.848 3.848 0 0 1 .52-1.925l.27-.481a3.86 3.86 0 0 1 1.404-1.405L22.7 3.984a3.851 3.851 0 0 1 1.925-.52h.558a3.85 3.85 0 0 1 1.924.52Zm9.354 9.835L25.183 7.314h-.558l-11.26 6.505 11.548 6.66 11.548-6.66Zm-11.548 2.66 4.614-2.66-4.622-2.666-4.61 2.663 4.618 2.663Zm1.925 7.348v13.319l11.259-6.506.289-.48V17.148l-11.548 6.678Zm8.083-.673-4.619 2.672v5.317l4.62-2.669v-5.32Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.614 7.297h.558l11.279 6.505-11.548 6.66-11.548-6.66 11.26-6.505ZM38.102 30.668l-11.259 6.505V23.854l11.548-6.678v13.01l-.289.482Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "relume_color_large_react_svg__b",
    x1: 6.272,
    x2: 44.514,
    y1: 6.813,
    y2: 10.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6248FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "relume_color_large_react_svg__c",
    x1: 4.127,
    x2: 46.3,
    y1: 0,
    y2: 4.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6248FF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "relume_color_large_react_svg__a",
    width: 49.809,
    height: 53.3,
    x: 0.216,
    y: 0.756,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1580_18804",
    stdDeviation: 3.028
  })))));
};
export default SvgRelumeColorLargereact;